<template>
<div>
    <h2>{{ $t("mobileAppInstructionsView.title") }}</h2>
    <p v-for="(paragraph, i) in store.globalSettings.mobileInstructions ? store.globalSettings.mobileInstructions.split('\n') : ''" class="about" :key="i">
        {{ paragraph }}
    </p>
</div>
</template>


<script lang="ts">
import { store } from "store";
import { defineComponent } from "vue";

export default defineComponent({
    data() {
        return {
            store: store
        };
    },
    created() {
        store.page.title = this.$t("mobileAppInstructionsView.title") as string;
        store.page.showTopNav = true;
    }
})

</script>